import React, { useContext, ReactNode } from "react";
import { Accordion, AccordionContext, Card } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { DomainCompetency } from "Stores/courseStore";
import { CaretDownIcon } from "Components/Icons/CaretDown";
import { CaretRightIcon } from "Components/Icons/CaretRight";

interface CustomToggleProps {
    eventKey: string;
    children?: ReactNode;
    hasChildren: boolean;
    selectedId: string;
}

const CustomToggle = ({ children, eventKey, hasChildren, selectedId }: CustomToggleProps) => {
    const currentContext = useContext(AccordionContext);
    const isCurrentEventKeyActive = currentContext?.activeEventKey === eventKey;
    const decoratedOnClick = useAccordionButton(eventKey);

    return (
        <button
            type="button"
            onClick={decoratedOnClick}
            className={selectedId === eventKey ? "competencyItemSelected" : "competencyItem"}
        >
            {hasChildren && (
                isCurrentEventKeyActive ? (
                    <CaretDownIcon className="drop-icon" size="14" />
                ) : (
                    <CaretRightIcon className="drop-icon" size="14" />
                )
            )}
            {children}
        </button>
    );
};

interface RecursiveAccordionProps {
    data: DomainCompetency[];
    level?: number;
    onItemClick: (competency: DomainCompetency) => void;
    selectedId: string;
}

export const RecursiveAccordion = ({
    data,
    level = 0,
    onItemClick,
    selectedId,
}: RecursiveAccordionProps) => {
    return (
      <Accordion className="recursive-accordion">
        {data.map((item) => (
          <Card key={item.ruuid}>
            <Card.Header
              style={{ paddingLeft: `${level * 20}px` }}
              className={`accordionLevel${level} ${selectedId === item.ruuid ? "competencyItemSelected" : "competencyItem"}`}
              onClick={() => onItemClick(item)}
            >
              <CustomToggle
                eventKey={item.ruuid}
                hasChildren={item.children.length > 0}
                selectedId={selectedId}
              >
                <span
                  className={
                    selectedId === item.ruuid
                      ? "competencyItemSelected"
                      : "competencyItem"
                  }
                >
                  {item.standard_name}
                </span>
              </CustomToggle>
            </Card.Header>
            {item.children.length > 0 && (
              <Accordion.Collapse eventKey={item.ruuid}>
                <Card.Body>
                  <RecursiveAccordion
                    data={item.children}
                    level={level + 1}
                    onItemClick={onItemClick}
                    selectedId={selectedId}
                  />
                </Card.Body>
              </Accordion.Collapse>
            )}
          </Card>
        ))}
      </Accordion>
    );
};
